import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <SEO
        title="Page Not Found | V&D Storage Streetman"
        description="The page you're looking for doesn't exist. Visit V&D Storage Streetman for boat, RV, and self storage near Richland Chambers Lake."
        canonical="/404"
      />
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors"
          >
            <Home className="h-5 w-5 mr-2" />
            Go Home
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center px-6 py-3 text-green-600 border-2 border-green-600 rounded-lg hover:bg-green-50 transition-colors"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
